/* Global Message */
export const SET_GLOBAL_MESSAGE = "SET_GLOBAL_MESSAGE";
export const SET_GLOBAL_MESSAGE_SUCCESS = "SET_GLOBAL_MESSAGE_SUCCESS";
export const SET_GLOBAL_MESSAGE_ERROR = "SET_GLOBAL_MESSAGE_ERROR";
